var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
const StyledCalendarIcon = styled.svg `
  width: ${(props) => props.width || '24px'};
  height: ${(props) => props.height || '24px'};
  flex-shrink: 0;

  path {
    fill: ${(props) => props.iconColor || 'currentColor'};
  }
`;
export const CalendarIcon = (_a) => {
    var { iconColor } = _a, props = __rest(_a, ["iconColor"]);
    return (_jsx(StyledCalendarIcon, Object.assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", iconColor: iconColor }, props, { children: _jsx("path", { d: "M17 3h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h4V1h2v2h6V1h2v2zm-2 2H9v2H7V5H4v4h16V5h-3v2h-2V5zm5 6H4v8h16v-8z" }) })));
};
export default CalendarIcon;
//# sourceMappingURL=CalendarIcon.js.map